<mat-dialog-content class="app-allergy-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-allergy-dialog__title">
            {{
                data.allergy.id
                    ? ('apps.patient.overview.editAllergy' | translate)
                    : ('apps.patient.overview.addAllergy' | translate)
            }}
        </h2>
        <app-allergies-form
            [formGroup]="allergiesForm"
            [isActive]="true"
            [isReadOnly]="true"
            [isBedSideMode]="data.isBedSideMode"
        ></app-allergies-form>
    </div>

    <div class="app-allergy-dialog__actions">
        <button mat-button class="app-allergy-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
